import { Link, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import useAPI from "hooks/useAPI";
import scss from "./ProductNavigation.module.scss";

const ProductNavigation = ({ count }) => {
    const { pathname } = useLocation();
    const api = useAPI();
    const { data: promotions } = useQuery(["PromoPage"], () => api.list("/landing-pages/list"), { refetchOnWindowFocus: false });
    const links = [["/pocetna", "Svi proizvodi"], ["/novo", "Nova ponuda"]];
    if (promotions?.items?.length > 0) links.push(["/promo", "Promocije"]);
    const active = pathname.startsWith("/novo") ? "/novo" : pathname.startsWith("/promo") ? "/promo" : "/pocetna";

    return (
        <div className={scss.wrapper}>
            <nav className={scss.links} aria-label="Ponuda proizvoda">
                {links.map(([url, label]) => (
                    <Link key={url} to={url} className={active === url ? scss.active : undefined} aria-current={active === url ? "page" : undefined}>{label}</Link>
                ))}
            </nav>
            {count !== undefined && <span className={scss.count}>Ukupno proizvoda: <strong>{count}</strong></span>}
        </div>
    );
};

export default ProductNavigation;
